// read all the error messages from this file to maintain consistency across the codebase

export const NOTIFICATION_MESSAGES = {
   ALREADY_DISTRIBUTED: 'Already distributed',
   CHANGES_DISCARD_SUCCESS: 'Changes discard successfully',
   CHANGES_NOT_SAVED: 'Please save your existing changes',
   DISTRIBUTION_DELETE_SUCCESS: 'Distribution group deleted successfully',
   DISTRIBUTION_GROUP_DOES_NOT_EXIST:
      'Distribution group is either in distributed state or does not exist',
   EMPTY_FIELD: 'Required field is empty',
   EMPTY_QUERY_NAME: 'Query name is empty',
   EMPTY_SEARCH_CRITERIA: 'Search criteria is empty.',
   EMPTY_TARIFF_VALUE: 'Tariff number field is empty',
   FILE_ATTACHMENTS_UNAVAILABLE: 'No file attachments are available',
   INCORRECT_FILE_TYPE: 'Incorrect file extension',
   INVALID_DATE_TIME_FORMAT:
      'date time format is invalid, please use DDMMMYY HH:MM format',
   INVALID_DISTRIBUTION_NUMBER: 'Invalid distribution number',
   MAX_LENGTH_SIX_CHARS: 'Please enter a 6 digit number',
   NO_DATA_AVAILABLE: 'No data available',
   PAGINATION_IN_PROGRESS:
      'Pagination is in-progress, please wait until pagination is complete',
   QUERY_ALREADY_PRESENT: 'Query already exists',
   QUERY_SAVE_SUCCESS: 'Query name saved successfully',
   RECORD_DELETE_SUCCESS: 'Record deleted successfully',
   RECORD_NOT_UPDATED: 'Please update record and click to save',
   RECORD_UPDATE_SUCCESS: 'Record updated successfully',
   ROW_NOT_SELECTED: 'Please select a row',
   INVALID_DATE_FORMAT: 'Invalid date format',
   DISTRIBUTION_NUMBER_MAX_LENGTH:
      'Distribution group number length should be 6 digits',
   SEARCH_STOPPED: 'Stopped fetching more data',
   INVALID_MATH_OPERATION_AMOUNT_FIELD_FORMAT:
      'Amount update must use one of these formats (=+10 ,=-10 ,=*10, =/10).',
   SEARCH_COMPLETED:
      'Successfully fetched all data. Data export is available now',
};
